'use client'

import './index.scss'

export default function RouterLoading({loading}: {loading: boolean}) {
    return (
        loading ? <div className='flex items-center bg-black/40 justify-center fixed h-full w-full top-0 left-0 z-20'>
            <div className='spin'></div>
        </div> : null
    )
}
